import { render } from "./PaymentSuccess.vue?vue&type=template&id=115b5fe2&scoped=true"
const script = {}

import "./PaymentSuccess.vue?vue&type=style&index=0&id=115b5fe2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115b5fe2"]])

export default __exports__